import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export interface CreateTeamDto {
    name: string;
    role: string;
    warehouseId: string;
}

export const createTeam = async (dto: CreateTeamDto, callback: CallbackObject<any>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res: AxiosResponse = await instance.post(`/management/teams`, dto, config);
        callback.success(res.data);
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
